/**
 * GSTR9CNew Common selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGstr9cNewCommon = (state) => state.gstr9cNewCommon || initialState;

const makeSelectLoaderStatus = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.loaderStatus);

const makeSelectProfileData = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.profileData);

const makeSelectEntityList = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.entityList);

const makeSelectNotificationStatus = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.notificationStatus);

const makeSelectNotificationMessage = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.notificationMessage);

const makeSelectResponseStatus = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.responseStatus);

const makeSelectResponseMessage = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.responseMessage);

const makeSelectResponseError = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.responseError);

const makeSelectTableData = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.tableData);

const makeSelectTotalRecords = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.totalRecords);

const makeSelectRecords = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.records);

const makeSelectUploadStatus = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.uploadStatus);

const makeSelectValidationError = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.validationError);

const makeSelectApiSuccess = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.apiSuccess);

const makeSelectApiError = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.apiError);

const makeSelectSelectedEntity = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.selectedEntity);

const makeSelectSelectedGstin = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.selectedGstin);

const makeSelectSelectedReturnPeriod = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.selectedReturnPeriod);

const makeSelectPrepareGSTR9CSummary = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.prepareGSTR9CSummary);

const makeSelectGSTR9CHistoryData = () =>
  createSelector(selectGstr9cNewCommon, (substate) => substate.gstr9CHistoryData);

export {
  selectGstr9cNewCommon,
  makeSelectLoaderStatus,
  makeSelectProfileData,
  makeSelectEntityList,
  makeSelectNotificationStatus,
  makeSelectNotificationMessage,
  makeSelectResponseStatus,
  makeSelectResponseMessage,
  makeSelectResponseError,
  makeSelectTableData,
  makeSelectTotalRecords,
  makeSelectRecords,
  makeSelectUploadStatus,
  makeSelectValidationError,
  makeSelectApiSuccess,
  makeSelectApiError,
  makeSelectSelectedEntity,
  makeSelectSelectedGstin,
  makeSelectSelectedReturnPeriod,
  makeSelectPrepareGSTR9CSummary,
  makeSelectGSTR9CHistoryData,
};
